export const PaymentEvents = {
  CHEST_OWNED: 'chest-owned-event',
};
